<div
  class="sticky top-0 z-30 bg-white shadow shadow-bottom flex flex-row items-center w-full h-16 pl-5 overflow-hidden"
>
  <app-small-button-atom
    [icon]="'arrow-left'"
    [text]="'Retour'"
    (click)="goBack()"
  ></app-small-button-atom>
  <app-horizontal-filter-list-atom
    class="w-full"
    [items]="entities$ | async"
    (clickItem)="navigateToShop($event)"
  ></app-horizontal-filter-list-atom>
</div>
